export default __webpack_public_path__ + "static/media/Asset7_lrg.096dcffb.png";